import {byte, int, unitValue} from "@opendaw/lib-std"
import {PPQN, ppqn} from "@opendaw/lib-dsp"

export type DrumLane = {
    name: string
    note: byte
    steps: int
    pulses: int
    rotation: int
    resolution: ppqn
    accents: int
    probability: unitValue
    velocity: unitValue
    accentVelocity: unitValue
    humanize: ppqn
    mute: boolean
    // A locked lane is left alone by the density macro and by the per-track dice. The kick is locked, which
    // is what keeps it four to the floor.
    locked: boolean
}

export namespace DrumLane {
    export const CycleBars: int = 4
    export const CycleDuration: ppqn = PPQN.Bar * CycleBars

    export const defaults = (): Array<DrumLane> => [
        lane("Kick", 36, 16, 4, 0, {accents: 1, velocity: 1.0, locked: true}),
        lane("Clap", 39, 16, 2, 4, {accents: 1}),
        lane("Snare", 38, 16, 3, 12, {accents: 1, probability: 0.6, velocity: 0.6}),
        lane("Closed Hat", 42, 16, 11, 0, {accents: 4, velocity: 0.55, humanize: 6}),
        lane("Open Hat", 46, 16, 2, 2, {accents: 0, velocity: 0.7}),
        lane("Rim", 40, 12, 5, 3, {accents: 2, probability: 0.7, velocity: 0.5}),
        lane("Cowbell", 50, 10, 3, 1, {accents: 1, probability: 0.4, velocity: 0.45}),
        lane("Maracas", 44, 24, 7, 5, {accents: 3, probability: 0.8, velocity: 0.4, humanize: 8})
    ]

    const lane = (name: string, note: byte, steps: int, pulses: int, rotation: int,
                  options: Partial<DrumLane> = {}): DrumLane => ({
        name,
        note,
        steps,
        pulses,
        rotation,
        resolution: PPQN.SemiQuaver,
        accents: 1,
        probability: 1.0,
        velocity: 0.8,
        accentVelocity: 1.0,
        humanize: 0,
        mute: false,
        locked: false,
        ...options
    })
}
